export default "__VITE_ASSET__GLrITGKw__"